<div class="input radio-list" [ngClass]="'radio-list--' + style">
  <div class="radio-list__items">
    <ftr-radio
      *ngFor="let item of items | async"
      class="radio-list__item"
      [name]="name"
      [label]="item.key"
      [value]="item.value"
      [summary]="item.summary"
      [summaryTemplate]="item.summaryTemplate || null"
      [control]="control"
    ></ftr-radio>
  </div>

  <span
    class="input__validation"
    ftrValidationErrorHint
    [label]="validationLabel"
    [ngFormControl]="control"
    [controlTouched]="control.touched"
    [submitAttempted]="submitAttempted"
  ></span>
</div>
